import React, { useEffect, useState } from 'react';

import './GeneralImageUpload.css';

const GeneralImageUpload = props => {

    const [file, setFile] = useState();
    const [previewUrl, setPreviewUrl] = useState();

    useEffect (() => {
        if (!file) {
            setPreviewUrl(null)
            return; 
            
        } else {
            const fileReader = new FileReader();
            fileReader.onload = () => {
                setPreviewUrl(fileReader.result);
            };
            fileReader.readAsDataURL(file);
        }
    }, [file])

    const pickHandler = data => {
        if(data.target.files) {
           const pickedFile = data.target.files[0];
           setFile(pickedFile);
        }    
    };

    return (
        <div className='file-selection__wrapper'>
        <label htmlFor={props.id}>
            <div  className="button button-primary upload-gpimg-btn"> 
                <span>choose image</span>
            </div>
            <img 
                className="gen-image-preview" 
                src={previewUrl} 
                alt={props.alt} 
            />
        </label>
            <input 
                id={props.id} 
                name={props.id}
                ref={props.refs}  
                type="file" 
                accept=".jpg,.png,.jpeg" 
                onChange={pickHandler} 
            />
        </div>
    );
};


export default GeneralImageUpload;